// ui/data/keys.js — the query keys of the shared cache (src/ui/data).
//
// Kept in a module with NO imports so services/http.js can map a write to
// the keys it invalidates (./invalidation.js) without an import cycle.
//
// Prefixes are what gets invalidated: ['bots'] covers every bot list,
// ['portfolio'] summary + history + exposure, ['scanners'] every scanner read.
export const qk = {
  risk: ['risk'],
  bots: ['bots'],
  /** GET /api/trading_bots[?status=…] as the server returns it. */
  botsRaw: (status = null) => ['bots', 'raw', status || 'regular'],
  /** regular + scanner_profile, merged and formatted for AutoTrader (socket-patched). */
  botsMerged: ['bots', 'merged'],
  /**
   * { entries, offset, total, done } — one bot's history pages (+ socket
   * entries). Not under 'bots', so a bot write does not re-read every history.
   */
  botHistory: (botId) => ['botHistory', Number(botId)],
  /**
   * The Portfolio bot feed { stats, live, history } — written ONLY by the
   * socket (ui/data/liveCache), never fetched, so it is outside every
   * invalidated prefix.
   */
  botFeed: ['live', 'botFeed'],
  userHistories: ['bots', 'userHistories'],
  /**
   * GET /api/scanner/pnl-summary[?profileId=] — each scanner's lifetime P&L
   * over its bots. Under 'bots' on purpose: every bot write / list
   * invalidation re-reads it (and invalidateScanners covers 'bots' too).
   */
  scannerPnl: (profileId = null) => ['bots', 'scannerPnl', profileId == null ? 'all' : Number(profileId)],
  exchanges: ['exchanges'],
  alpacaStatus: ['alpaca', 'status'],
  drafts: ['drafts'],
  portfolio: ['portfolio'],
  portfolioSummary: ['portfolio', 'summary'],
  portfolioHistory: (range, scope) => ['portfolio', 'history', range, scope == null ? 'all' : scope],
  exposure: (scope) => ['portfolio', 'exposure', scope == null ? 'all' : scope],
  allocation: ['allocation'],
  scanners: ['scanners'],
  scannerProfiles: ['scanners', 'profiles'],
  /** One profile's spawned bots (GET /api/trading_bots?spawned_from=&limit=50); null = unreadable. */
  scannerSpawned: (id) => ['scanners', 'spawned', Number(id)],
  scannerProfile: (id) => ['scanners', 'profile', Number(id)],
  scannerHits: (params) => ['scanners', 'hits', params],
  scannerHealth: ['scanners', 'health'],
  backtest: ['backtest'],
  backtestActive: ['backtest', 'active'],
  /** Every queued / running test of the user (the shell's Running indicator). */
  backtestRunning: ['backtest', 'running'],
  backtestResults: (limit) => ['backtest', 'results', limit],
  research: ['research'],
};
